import { SettingsElementType } from '../types';
import { SettingsBoolElement } from './SettingsBoolElement';
import { SettingsDropdownElement } from './SettingsDropdownElement';
import SettingsInfoElement from './SettingsInfoElement';
import SettingsLinkElement from './SettingsLinkElement';
import SettingsTextElement from './SettingsTextElement';

export function SettingElement(props: { element: SettingsElementType }) {
    if (props.element.type === 'bool') {
        return <SettingsBoolElement name={props.element.name} settingKey={props.element.value} hint={props.element.hint} />;
    } else if (props.element.type === 'dropdown') {
        return (
            <SettingsDropdownElement
                id={props.element.id}
                name={props.element.name}
                settingKey={props.element.value}
                options={props.element.options}
                hint={props.element.hint}
            />
        );
    } else if (props.element.type === 'link') {
        return <SettingsLinkElement element={props.element} />;
    } else if (props.element.type === 'text-input') {
        return <SettingsTextElement element={props.element} />;
    } else if (props.element.type === 'text') {
        return <SettingsInfoElement element={props.element} />;
    } else if (props.element.type === 'custom') {
        return props.element.element;
    }

    return <div>Unimplemented</div>;
}
